import React from "react";
import "./Ourmap.css";
import mapPresence from "../../Media/mapresence.svg";

const Ourmap = () => {
  return (
    <div className="map-section">
      <div className="map-section-heading">
        <h2 className="map-section-heading-text">Our Presence</h2>
      </div>
      <div className="map-section-content">
        <p className="map-section-content-text">
          Our service areas include USA, UK, Middle East, India, and Africa.
          Once you partner with us, your goals become our goals. Our job has
          always been to meet your needs and keep your operations running
          smoothly.
        </p>
      </div>
      <div className="map-section-image">
        <img className="map-section-image-img" src={mapPresence} alt="Althi Solutions global presence map"
 />
      </div>
    </div>
  );
};

export default Ourmap;
